import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, onUnmounted, nextTick } from 'vue'

  import MaintenanceBanner from '@/components/MaintenanceBanner.vue'
  import SaleBanner from '@/components/SaleBanner.vue'
  import GetYourOwnAcademyBanner from '@/components/GetYourOwnAcademyBanner.vue'
  import MainNavBar from '@/components/MainNavBar.vue'
  import EditorButtons from '@/components/editor/EditorButtons.vue'
  import TrialStatusBanner from '@/components/TrialStatusBanner.vue'
  import Sidebar from '@/components/Sidebar.vue'

  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'
  import useEditor from '@/composables/useEditor'
  import useBreakpoint from '@/composables/useBreakpoint'
  import { useRoute } from 'vue-router/composables'

  import { CourseModule } from '@/store/modules/course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  emits: ['hide-widgets', 'show-widgets'],
  setup(__props, { emit }) {

  

  const route = useRoute()
  const { isSachkundeCompany, isKetchUpCompany, logoUrl, hasValidUser } = useCommonMixin()
  const { hasPurchasedAtLeastACourse, courseBundles } = useCourse()
  const { inEditorMode } = useEditor(route)
  const { isLargeDesktop } = useBreakpoint()
  const showGetYourOwnAcademyBanner = ref(false)
  const headerRef = ref<HTMLElement | null>(null)
  const resizeObserver = ref<ResizeObserver | null>(null)
  const isSidebarOpen = ref(false)
  const headerHeight = ref(0)
  const scrollY = ref(0)
  const resizeTimeout = ref<number | null>(null)

  const showMaintenanceBanner = computed(() => process.env.VUE_APP_MAINTENANCE_BANNER_VISIBLE === 'true')

  const showSaleBanner = computed(
    () =>
      process.env.VUE_APP_SALE_BANNER_VISIBLE === 'true' &&
      isSachkundeCompany.value &&
      hasValidUser.value &&
      courseBundles.value !== null &&
      !hasPurchasedAtLeastACourse.value,
  )

  const showTrialStatusBanner = computed(() => hasValidUser.value && CourseModule.course?.trial)

  const showMainNavBar = computed(() => {
    const isLoginOrResetPage = ['Login', 'ResetPassword'].includes(route.name as string)
    const showLogoIfPresent = isLoginOrResetPage ? logoUrl.value : true
    return isKetchUpCompany.value ? !isLoginOrResetPage && showLogoIfPresent : showLogoIfPresent
  })

  const toggleSidebar = () => {
    isSidebarOpen.value = !isSidebarOpen.value
  }

  const updateHeaderHeight = (entries: ResizeObserverEntry[]) => {
    if (resizeTimeout.value) {
      window.cancelAnimationFrame(resizeTimeout.value)
    }

    resizeTimeout.value = window.requestAnimationFrame(() => {
      if (entries[0]) {
        headerHeight.value = entries[0].contentRect.height
      }
    })
  }

  const handleScroll = () => {
    scrollY.value = window.scrollY
  }

  onMounted(() => {
    nextTick(() => {
      if (headerRef.value instanceof Element) {
        resizeObserver.value = new ResizeObserver(updateHeaderHeight)
        resizeObserver.value.observe(headerRef.value)
      }
    })
    window.addEventListener('scroll', handleScroll)
  })

  onUnmounted(() => {
    if (resizeObserver.value) {
      resizeObserver.value.disconnect()
    }
    if (resizeTimeout.value) {
      window.cancelAnimationFrame(resizeTimeout.value)
    }
    window.removeEventListener('scroll', handleScroll)
  })

return { __sfc: true,emit, route, isSachkundeCompany, isKetchUpCompany, logoUrl, hasValidUser, hasPurchasedAtLeastACourse, courseBundles, inEditorMode, isLargeDesktop, showGetYourOwnAcademyBanner, headerRef, resizeObserver, isSidebarOpen, headerHeight, scrollY, resizeTimeout, showMaintenanceBanner, showSaleBanner, showTrialStatusBanner, showMainNavBar, toggleSidebar, updateHeaderHeight, handleScroll, computed, ref, onMounted, onUnmounted, nextTick, MaintenanceBanner, SaleBanner, GetYourOwnAcademyBanner, MainNavBar, EditorButtons, TrialStatusBanner, Sidebar, useCommonMixin, useCourse, useEditor, useBreakpoint, useRoute, CourseModule }
}

})